import React from 'react'

export default function Search({ color, width = '18' }) {
  return (
    <svg
      id="icon-search"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 18 18"
      width={width}
      height="100%"
    >
      <path
        fill={color || '#414141'}
        d="M7.197.985c3.972 0 7.197 3.174 7.197 7.094 0 1.63-.557 3.131-1.494 4.328l4.767 3.754a.75.75 0 11-.928 1.178l-4.888-3.848a7.231 7.231 0 01-4.654 1.683C3.225 15.174 0 12 0 8.079 0 4.16 3.225.985 7.197.985zm0 1.5C4.047 2.485 1.5 4.993 1.5 8.08c0 3.087 2.548 5.595 5.697 5.595s5.697-2.508 5.697-5.595c0-3.086-2.548-5.594-5.697-5.594z"
      />
    </svg>
  )
}
